import { FC } from 'react';
import { Svg, Text } from '@hopskipdrive/react-components';
import {
  AccordionDetails,
  AccordionDetailsProps,
  AccordionProps,
  AccordionSummary,
  AccordionSummaryProps,
} from '@mui/material';

import { StyledAccordion } from './Accordion.styles';

export const Accordion = ({ children, ...rest }: AccordionProps): JSX.Element => {
  return <StyledAccordion {...rest}>{children}</StyledAccordion>;
};

const AccordionHeader: FC<AccordionSummaryProps> = ({ children, ...rest }) => (
  <AccordionSummary expandIcon={<Svg icon="arrow" />} {...rest}>
    {children}
  </AccordionSummary>
);

const AccordionBody: FC<AccordionDetailsProps> = ({ children, ...rest }) => (
  <AccordionDetails {...rest}>{children}</AccordionDetails>
);

const AccordionTitle: FC<{ children }> = ({ children }) => (
  <Text variant="h2" fontWeight={700}>
    {children}
  </Text>
);

Accordion.Header = AccordionHeader;
Accordion.Body = AccordionBody;
Accordion.Title = AccordionTitle;
